// extracted by mini-css-extract-plugin
export default {"container":"inventoryButtons_container__AFS0k","left":"inventoryButtons_left__Js42n","right":"inventoryButtons_right__p7ayq"};